import { ContainerErrorType } from '@fluidframework/container-definitions';
import { DriverErrorType } from '@fluidframework/driver-definitions';
import { OWHErrorType } from '@fluidx/office-fluid-types';
import { OdspErrorType } from '@fluidframework/odsp-driver-definitions';
import { tryMatchContainerErrorType, tryMatchDriverErrorType, tryMatchOdspDriverErrorType, tryMatchOWHErrorType } from '@fluidx/utilities';
import { getStringTableIfNeeded } from '../../../utilities/localizationUtilities.dynamic';
import { UnknownError } from '../ErrorInfo';
export async function getBannerMessagingForError(error, stringTableOrLocale) {
    const stringTable = await getStringTableIfNeeded(stringTableOrLocale);
    const defaultBannerErrorInfo = {
        errorType: UnknownError,
        bannerStrings: {
            bannerTitle: stringTable.criticalErrorBannerTitle,
            bannerMessage: stringTable.criticalErrorBannerMessage
        }
    };
    const bannerErrorInfo = getBannerMessagingForContainerError(error, stringTable) || getBannerMessagingForOdspDriverError(error, stringTable) || getBannerMessagingForBaseDriverError(error, stringTable) || defaultBannerErrorInfo;
    return Promise.resolve(bannerErrorInfo);
}
/**
 * Select appropriate localized string for container errors
 */ function getBannerMessagingForContainerError(error, stringTable) {
    const errorType = tryMatchContainerErrorType(error) || tryMatchOWHErrorType(error);
    if (!errorType) {
        return;
    }
    switch(errorType){
        case OWHErrorType.ContainerUpgradeRequired:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.containerUpgradeRequiredBannerTitle,
                    bannerMessage: stringTable.containerUpgradeRequiredBannerMessage
                }
            };
        // TODO: change strings to match the semantics of a recoverable warning
        case ContainerErrorType.throttlingError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: '',
                    bannerMessage: stringTable.containerThrottleErrorBannerMessageV2
                }
            };
        case ContainerErrorType.genericError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.criticalErrorBannerTitle,
                    bannerMessage: stringTable.criticalErrorBannerMessage
                }
            };
        default:
            return;
    }
}
/**
 * Select appropriate localized string for base driver errors
 */ function getBannerMessagingForBaseDriverError(error, stringTable) {
    const errorType = tryMatchDriverErrorType(error);
    if (!errorType) {
        return;
    }
    switch(errorType){
        case DriverErrorType.fileNotFoundOrAccessDeniedError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.fileNotFoundOrAccessDeniedBannerTitle,
                    bannerMessage: stringTable.fileNotFoundOrAccessDeniedBannerMessage
                }
            };
        case DriverErrorType.authorizationError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.authorizationErrorBannerTitle,
                    bannerMessage: stringTable.authorizationErrorBannerMessage
                }
            };
        case DriverErrorType.throttlingError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.genericServiceBusyBannerTitle,
                    bannerMessage: stringTable.genericServiceBusyBannerMessage
                }
            };
        case DriverErrorType.genericError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.criticalErrorBannerTitle,
                    bannerMessage: stringTable.criticalErrorBannerMessage
                }
            };
        default:
            return;
    }
}
/**
 * Select appropriate localized string for Odsp specific driver errors
 */ function getBannerMessagingForOdspDriverError(error, stringTable) {
    const errorType = tryMatchOdspDriverErrorType(error);
    if (!errorType) {
        return;
    }
    switch(errorType){
        case DriverErrorType.fileOverwrittenInStorage:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.odspVersionMismatchBannerTitle,
                    bannerMessage: stringTable.odspVersionMismatchBannerMessage
                }
            };
        case OdspErrorType.outOfStorageError:
            return {
                errorType,
                bannerStrings: {
                    bannerTitle: stringTable.odspOutOfStorageBannerTitle,
                    bannerMessage: stringTable.odspOutOfStorageBannerMessage
                }
            };
        // TBD: Define error messaging for these Odsp error cases
        case OdspErrorType.invalidFileNameError:
        case OdspErrorType.snapshotTooBig:
        case OdspErrorType.fetchTimeout:
        case OdspErrorType.fluidNotEnabled:
        default:
            return;
    }
}
export async function getBannerMessagingForContainerState(containerState, stringTableOrLocale) {
    const stringTable = await getStringTableIfNeeded(stringTableOrLocale);
    switch(containerState){
        case 'Disconnected':
            return {
                bannerTitle: stringTable.disconnectedStateBannerTitle,
                bannerMessage: stringTable.disconnectedStateBannerMessage
            };
        case 'Readonly':
            return {
                bannerTitle: stringTable.readonlyStateBannerTitle,
                bannerMessage: stringTable.readonlyStateBannerMessage
            };
        case 'ReadonlyMobile':
            return {
                bannerTitle: stringTable.readonlyStateBannerTitle,
                bannerMessage: stringTable.readonlyStateMobileBannerMessage
            };
    }
}
